module.exports = __webpack_public_path__ + "img/绑定套餐.d6068109.svg";